<!--<p>-->
<!--  menu-item works!-->
<!--</p>-->

@if (item.route) {
  <a
    class="menu-item"
    [routerLink]="item.route"
    [ngClass]="item.cssClass || ''"
    [class.active]="checkActiveLink()"
    (click)="onMenuItemClick()"
    >
    <ng-container
      *ngTemplateOutlet="content"
    ></ng-container>
  </a>
}

@if (!item.route) {
  <a
    class="menu-item"
    [ngClass]="item.cssClass || ''"
    [class.active]="checkActiveLink()"
    (click)="onMenuItemClick()"
    >
    <ng-container
      *ngTemplateOutlet="content"
    ></ng-container>
  </a>
}

<ng-template #content>
  <span class="icon">
    @if (item.imgIcon) {
      <img [src]="item.imgIcon" class="img-icon img-icon--default" alt="" />
      @if (item.imgIconHover) {
        <img [src]="item.imgIconHover" class="img-icon img-icon--hover" alt="" />
      }
    } @else {
      <i class="material-icons">{{ item.materialIcon }}</i>
    }
  </span>

  <span class="title"
    >{{ changeTitleForOtherUsers(item.text)
    }}@if (item.subMenu) {
    <span class="icon"
      ><i class="material-icons">chevron_right</i></span
      >
      }</span
      >

      @if (showNewAiCount) {
        <div class="new-ai-count">
          <span>{{newActionItemsCount}}</span>
        </div>
      }
    </ng-template>

    @if (item.subMenu) {
      <cm-sub-menu
        [items]="item.subMenu"
        class="sub-menu"
        [ngClass]="{ shifted: adaptiveSubmenu && menuService.isMinimized, hidden: !isSubmenuVisible }"
      ></cm-sub-menu>
    }
